export default __webpack_public_path__ + "static/media/p16.3ab75b9d.jpg";